import { Badge } from '@/Domain/components/Shared/Badge/Badge';
import { cn } from '@/Domain/utils/cn';
import { formatUnreadCount } from '@/UI/Insights/UnifiedAiInsights/utils/unreadCount';

interface UnreadCountBadgeProps {
  unread: number;
  capped: boolean;
  testId?: string;
}

// Lives inside a tab trigger that owns gap-0 — the wrapper's own ml-2/ml-0
// supplies the spacing only when the badge is visible. When unread crosses
// zero the wrapper collapses max-width + margin-left + opacity together over
// 300ms so the surrounding tabs slide in smoothly. The inner Badge has no
// width override so it renders at the same natural pill size as the Inbox
// counters in the sidebar.
export const UnreadCountBadge = ({ unread, capped, testId }: UnreadCountBadgeProps) => {
  const visible = unread > 0;
  return (
    <span
      aria-hidden={!visible}
      className={cn(
        'inline-flex items-center overflow-hidden transition-[max-width,opacity,margin-left] duration-300 ease-out',
        visible ? 'max-w-[3rem] opacity-100 ml-2' : 'max-w-0 opacity-0 ml-0',
      )}
    >
      <Badge variant="secondary" size="sm" data-testid={testId}>
        {formatUnreadCount(unread, capped)}
      </Badge>
    </span>
  );
};
